// Add a new CSS variable called --doc-height which takes into account height of mobile navbar
const documentHeight = () => {
  const doc = document.documentElement
  doc.style.setProperty('--doc-height', `${window.innerHeight}px`)
}

export default () => {
  documentHeight()
  window.addEventListener('resize', documentHeight)
}